import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.172 1.172C0 2.343 0 4.229 0 8s0 5.657 1.172 6.828S4.229 16 8 16h4c3.771 0 5.657 0 6.828-1.172S20 11.771 20 8s0-5.657-1.172-6.828S15.771 0 12 0H8C4.229 0 2.343 0 1.172 1.172M16.576 3.52a.75.75 0 0 1-.096 1.056l-2.196 1.83c-.887.74-1.605 1.338-2.24 1.746-.66.425-1.303.693-2.044.693s-1.384-.269-2.045-.693c-.634-.408-1.352-1.007-2.239-1.745L3.52 4.577a.75.75 0 0 1 .96-1.153L6.64 5.223C7.572 6 8.219 6.538 8.767 6.89c.529.34.888.455 1.233.455s.704-.114 1.233-.455c.547-.352 1.195-.89 2.128-1.667l2.159-1.8a.75.75 0 0 1 1.056.097",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }